<template>
  <AlertCard
    v-if="user && unverifiedDomain"
    data-id="unverified-domain-alert"
    :variant="Variant.warning"
    :links="[routerLink]"
    title="Domain verification pending"
    :text="'You have a custom domain that is not verified or is missing DNS records. Please view instructions on the domain page to verify your email domain.'"
  />
</template>
<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useStore3 } from '../../store/main';
import { storeToRefs } from 'pinia';
import { Variant } from '../../store/types';
import AlertCard from '../../components/tw/AlertCard.vue';

const store3 = useStore3();
const { user } = storeToRefs(store3);

onMounted(() => {
  store3.getDomainIssues();
});
const { domainIssues } = storeToRefs(store3);

const routerLink = computed(() => ({
  to: '/domains/',
  text: 'View domains',
}));

const unverifiedDomain = computed(() => domainIssues.value?.hasIssues ?? false);
</script>
